import httpClient from '../../shared/services/httpClient';

export const userCheckEmail = async (email: string) => {
  const response = await httpClient.get('/login/check-email', {
    params: { email },
    skipAuth: true,
  });
  return response.data as boolean;
};
